import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "app/store";
import "./index.css";
import { IntlProvider } from "react-intl";
import Wrapper from "./components/Wrapper";
import GlobalSpinner from "./features/CommonComponents/GlobalSpinner/GlobalSpinner";
// const container = <App />;
ReactDOM.render(
  <React.StrictMode>
    {/*Redux Provider is included access the store values from anywhere inside the child components.*/}
    <Wrapper>
      <Provider store={store()}>
        <GlobalSpinner appContainer={<App />}></GlobalSpinner>
      </Provider>
    </Wrapper>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
